export enum Language {
  KO = "ko",
  EN = "en",
}
